import { render, staticRenderFns } from "./Newborn.vue?vue&type=template&id=4553b180&scoped=true&"
import script from "./Newborn.vue?vue&type=script&lang=js&"
export * from "./Newborn.vue?vue&type=script&lang=js&"
import style0 from "./Newborn.vue?vue&type=style&index=0&id=4553b180&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553b180",
  null
  
)

export default component.exports